// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nCQL","left":"styles_left__3lDp5"};